var BaseView = require('./abstract/base');
var UIProgressButton = require('./components/upload-effect.js');

module.exports = BaseView.extend({
  events: {
    'click .uploader.progress-button.loading': 'cancelEvent'
  },

  cancelEvent: function (event) {
    this.trigger('cancel');
    this.cancel();
  },

  cancel: function () {
    this.canceled = true;
    this.progressBar.setProgress(0);
  },

  initialize: function () {
    this.attemptsLeft = 3;
    this.attemptDelay = 2000;

    BaseView.prototype.initialize.call(this);
    _.bindAll(this, 'setImage', 'onImageLoaded', 'onImageError', 'cancel');
  },

  render: function () {
    var html = this.template(this.getTemplateRenderData());
    this.$el.html(html).css({ width: 122.5, height: 86 });
    this.progressBar = new UIProgressButton(this.$el.find('.progress-button')[0]);
  },

  toggleProgressBar: function (isShow) {
    isShow && this.progressBar._submit();
  },

  updateProgressBar: function (value) {
    if (!this.canceled) {
      this.progressBar.setProgress(value);
      value === 1 && this.progressBar.stop(1);
    }
  },

  setImage: function (id, src) {
    if (!this.canceled) {
      var $image = $('<img>')
        .attr('id', id)
        .attr('src', src)
        .on('error', this.onImageError)
        .on('load', this.onImageLoaded);

      (src.match('\/original\/')) && _.delay(_.bind(function () {
        this.$el.find('a.item').is('.loaded') || $image.attr('src', '');
      }, this), 10000);

      this.$el.find('a.item').removeClass('hidden').append($image);
    }
  },

  onImageLoaded: function () {
    var $uploader = this.$el.find('.uploader');

    this.$el.find('a.item').addClass('loaded');
    this.progressBar.clear();
    this.resize();

    _.delay(function () { $uploader.remove(); }, 1000);
  },

  onImageError: function (event) {
    var $image = $(event.currentTarget);
    var hasAttemptsLeft = --this.attemptsLeft > 0;
    (this.attemptsLeft === 1) && $image.attr('src', INKIVE.ImagesFactory.getVersionUrl($image.attr('src'), 'original'));

    var setImage = _.partial(
      this.setImage,
      $image.attr('id'),
      $image.attr('src')
    );

    $image.remove();
    hasAttemptsLeft && _.delay(setImage, this.attemptDelay);
    if (!hasAttemptsLeft) {
      this.progressBar.setProgress(0);
      this.trigger('thumbnail_load_error');
    }
  },

  getTemplateRenderData: function () {
    return { upload: true };
  }
});
